module.exports = __webpack_public_path__ + "img/back-ground@3x.badafa99.png";